import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login';
import view from './modules/view';
import shoppingCart from './modules/shoppingCart'
import router from './modules/router'
import commdity from './modules/commdity'
import order from './modules/order'
import getters from './getters';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userName: null,
    shop_index: {
      indexCategory: [],
      slide: [],
      hotGoods: [],
      indexRecommendGoods: [],
      article: [],
      headerNav: [],
      middleNav: [],
      footerNav: [],
    },
    searchText:''
  },
  mutations: {
    set_shopIndex(state,val) {
      state.shop_index = val
    },
    set_search(state,val) {
      state.searchText = val
    },
    set_user_name(state, name) {
      state.userName = name;
    }
  },
  actions: {
  },
  modules: {
    login,
    view,
    shoppingCart,
    router,
    commdity,
    order
  },
  getters
})
